<template>
    <div class="upload-drop" :class="inline_upload_type" v-show="inline_drop_visible"
      @dragenter.prevent @dragover.prevent
    >
        <div v-if="inline_upload_type === 'dual'"
          v-window-drag-drop="{cb_drop: onInlineAttachmentsDrop}"
          class="drop-box"
        >
            <p>
                <i class="fas fa-paperclip"></i>
                <strong>
                  {{Language.say('editor.attachments')}}
                </strong>
                  {{Language.say('editor.drag_file')}}
            </p>
        </div>

        <div
          v-window-drag-drop="{cb_drop: onInlineImagesDrop}"
          class="drop-box"
        >
            <p>
                <i class="far fa-image"></i>
                <strong>
                  {{Language.say('editor.embed_image')}}
                </strong>
                {{Language.say('editor.drag_image')}}
            </p>
        </div>
    </div>
</template>

<script setup>
  import {ref}                      from 'vue'
  import {defineProps, defineEmits} from 'vue'
  import {onMounted, onUnmounted}   from 'vue'
  import Language                   from '@/js/Shared/Language/Language.js';
  import WindowDragController       from '@/js/Webmail/WindowDragController';

  const props = defineProps({
    inline_upload_type: {
      default: 'dual'
    },
  })

  const emit = defineEmits([
    'inlineImagesDrop', 'inlineAttachmentsDrop'
  ])

  const inline_drop_visible = ref(false);

  onMounted(() => {
    WindowDragController.register('inline-upload', {
      windowDragEnter : onWindowDragEnter,
      windowDragLeave : onWindowDragLeave,
      windowDrop      : onWindowDrop,
    });
  });

  onUnmounted(() => {
    WindowDragController.unregister('inline-upload');
  })

  const onWindowDragEnter = (event) => {
    if (event.dataTransfer.types.length === 0 || (event.dataTransfer.types[0] !== 'Files' && event.dataTransfer.types[1] !== 'Files')) {
      return;
    }

    setInlineDropVisibility(true);
  }

  const onWindowDragLeave = () => {
    setInlineDropVisibility(false);
  }

  const onWindowDrop = () => {
    setInlineDropVisibility(false);
  }

  const onInlineImagesDrop = (event) => {
    emit('inlineImagesDrop', event.dataTransfer);
    setInlineDropVisibility(false);
  }

  const onInlineAttachmentsDrop = (event) => {
    setInlineDropVisibility(false);
    emit('inlineAttachmentsDrop',  event.dataTransfer)
  }

  const setInlineDropVisibility = (value) => {
    inline_drop_visible.value = value;
  }
</script>
